import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
export var getExtension = function getExtension(file) {
  var indexOfDot = file.name.lastIndexOf(".");
  if (indexOfDot < 0 || indexOfDot + 1 === file.name.length) {
    return "unknown";
  }
  return file.name.slice(indexOfDot + 1);
};